// Pure JWT helpers shared between ams-functions.ts (cookie-based session) and
// nativeSessionStore.ts (the native-storage mirror) — kept dependency-free so
// neither auth module has to import the other.

export const decodeJwtExpiry = (token: string): Date | null => {
    try {
        const payloadBase64 = token.split('.')[1]
        const payload = JSON.parse(atob(payloadBase64))
        if (typeof payload.exp !== 'number') return null
        return new Date(payload.exp * 1000)
    } catch {
        return null
    }
}
